import { render, staticRenderFns } from "./input-phone.vue?vue&type=template&id=574e77a0&scoped=true&"
import script from "./input-phone.vue?vue&type=script&lang=ts&"
export * from "./input-phone.vue?vue&type=script&lang=ts&"
import style0 from "./input-phone.vue?vue&type=style&index=0&id=574e77a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574e77a0",
  null
  
)

export default component.exports